module.exports = __webpack_public_path__ + "img/Christmastreemask.426c2609.svg";